import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { connectForm, Form, Field, Submit } from '~/form'
import { Map, List, fromJS } from 'immutable'
import { dataTableItemUpdate, dataTableItemDelete } from '../actions'
import { Portal, Button, Popup } from 'semantic-ui-react'

export function DeletePrompt({ onAnswer }) {
  let deleteTrigger = (
    <a href="#" className="button-plain">
      Poista
    </a>
  )

  let deleteContent = (
    <div className="prompt">
      <b>Oletko varma?</b>
      <div className="prompt-button">
        <Button size="tiny" content="Kyllä" onClick={e => e.preventDefault() & onAnswer(true)} color="red" />
      </div>
    </div>
  )

  return <Popup trigger={deleteTrigger} content={deleteContent} on="click" position="top right" />
}

class DataTableEdit extends Component {
  static formSubmit(dispatch, formId, values, changed, meta, { isDelete = false } = {}) {
    if (isDelete) return dispatch(dataTableItemDelete(meta.tableId, meta.entity, meta.itemId, formId))

    dispatch(dataTableItemUpdate(meta.tableId, meta.entity, meta.itemId, values.get(meta.itemId, Map()), formId))
  }

  static formValidation = (values, changed, meta) => {
    let { fields = [], itemId } = meta

    return fields.reduce((validations, { name, validation = [], override = {} }) => {
      if (override.update && override.update.validation) validation = override.update.validation

      validations[`${itemId}.${name}`] = validation
      return validations
    }, {})
  }

  setMeta = props => {
    let { formSetMeta, tableId, entity, config, itemId } = props
    let meta = {
      tableId,
      itemId,
      entity,
      fields: config.get('formFields', List()).toJS(),
    }

    formSetMeta(meta)
  }

  componentWillMount() {
    this.setMeta(this.props)
    let { item, itemId, formState, formInit } = this.props
    if (itemId && item) {
      let { values = Map() } = formState
      formInit(values.set(itemId, item))
    }
  }

  componentWillReceiveProps(nextProps) {
    if ((this.props.item === undefined && nextProps.item) || nextProps.itemId !== this.props.itemId) {
      let { values = Map() } = nextProps.formState
      nextProps.formInit(values.set(nextProps.itemId, nextProps.item))
      this.setMeta(nextProps)
    }
  }

  componentWillUnmount() {
    let { formReset } = this.props
    formReset()
  }

  componentDidMount() {
    if (!this._parent) return

    let input = this._parent.querySelector('input')
    input ? input.focus() : null
  }

  render() {
    let {
      config,
      configLoading,
      formUpdate,
      formSubmit,
      formState,
      formLoading,
      onCancel,
      dataId,
      itemId,
      active,
      editComponent = false,
      wide,
    } = this.props

    let fields = config.get('formFields', List())

    let classes = ['datatable-action-overlay']
    if (active) classes.push('datatable-action-overlay--active')

    let innerClasses = ['datatable-action', 'datatable-action--edit']
    if (wide) innerClasses.push('datatable-action--wide')

    return (
      <Portal open={active}>
        <div className={classes.join(' ')}>
          <div className={innerClasses.join(' ')} ref={el => (this._parent = el)}>
            <div className="datatable-action-title">Muokkaus</div>
            <Form onSubmit={formSubmit} formState={formState}>
              {editComponent ? (
                React.createElement(editComponent, this.props)
              ) : (
                <Fragment>
                  <div className="datatable-action-content">
                    {fields
                      .toJS()
                      .map(
                        ({
                          label,
                          inputLabel,
                          type,
                          name,
                          options = [],
                          referenceConfig = {},
                          multiple = false,
                          placeholder = '',
                          ...inputProps
                        }) => {
                          return (
                            <Field
                              {...inputProps}
                              label={label}
                              inputLabel={inputLabel}
                              type={type}
                              name={itemId + '.' + name}
                              options={options}
                              multiple={multiple}
                              referenceConfig={referenceConfig}
                              key={itemId + '.' + name}
                              onChange={formUpdate}
                              placeholder={placeholder}
                              disabled={name === dataId}
                              formState={formState}
                            />
                          )
                        }
                      )}
                  </div>
                  <div className="datatable-action-buttons datatable-action-buttons--flex">
                    <div>
                      <Submit content="Tallenna" icon="save" color="green" />
                      <button className="datatable-action-button-cancel" onClick={e => e.preventDefault() & onCancel()}>
                        Sulje
                      </button>
                    </div>
                    <div>
                      <DeletePrompt onAnswer={answer => (answer ? formSubmit({ isDelete: true }) : null)} />
                    </div>
                  </div>
                </Fragment>
              )}
            </Form>
          </div>
        </div>
      </Portal>
    )
  }
}

export default connectForm('datatable-edit', DataTableEdit)
